//@ts-nocheck
import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import PageNotFound from '../pages/ErrorPage/PageNotFound';
import OrderList from '../pages/Order/OrderList';
import StatusList from '../pages/Status/StatusList';
import PrivateRoute from './PrivateRoute';
import LocationList from '../pages/Location/LocationList';
import CreateLocation from '../pages/Location/CreateLocation';
import Setting from '../pages/Setting/Setting';
import BranchList from '../pages/Branch/BranchList';
import PickupBranchList from '../pages/PickupBranch/PickupBranchList';
import DestinationBranchList from '../pages/DestinationBranch/DestinationBranchList';
import { WelcomeRouterService } from '@careinfo/welcome-page-service';
import { getKey } from '../helpers/sessionKey';
const Router = () => {
  const shouldShowWelcome = getKey('shouldShowWelcome');
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path='/delivery/overview' element={<h1>OverView</h1>} />
        <Route
          path={'/delivery'}
          element={
            shouldShowWelcome === 'true' || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <h1>OverView</h1>
            )
          }
        />
        <Route path={`/delivery/:slug`} element={<StatusList />} />
        <Route
          path={`/delivery/:slug/status`}
          element={<StatusList />}
        />
        <Route
          path={`/delivery/:slug/location`}
          element={<LocationList />}
        />
        <Route
          path={`/delivery/:slug/branch`}
          element={<BranchList />}
        />
        <Route
          path={`/delivery/:slug/setting`}
          element={<Setting />}
        />
        <Route path='/delivery/order' element={<OrderList />} />
        <Route path='/*' element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
